import React, { Component } from 'react';
import { List, Card, Icon, Popup } from 'semantic-ui-react';
import AffixInfo from './AffixInfo';

export default class AffixContent extends Component {

    render() {

        const {affix} = this.props;

        if(!affix) {
            return null;
        }

        const popup = <Popup
                        trigger={<a>{affix.Name.English}</a>}
                        content={<AffixInfo modifiers={affix.Modifiers} name={affix.Name} position={affix.Position}/>}
                      />
        return (
            <Card.Content>
                <List.Item>
                    <Icon name="magic" /> {popup}
                </List.Item>
            </Card.Content>
        );
    }
}


// WEBPACK FOOTER //
// ./src/items/detail/summary-card/affixes/AffixContent.jsx